// Rawaj Partners (marketing.rawaj.live): marketers' links land on
// rawajbusiness.com/?ref=<code>. The code is kept for 30 days in a cookie and
// localStorage (last click wins) and sent with sign-up, so the marketer is
// credited when the new business pays.
const KEY = 'rb_ref'
const MAX_AGE_DAYS = 30
const MAX_AGE_MS = MAX_AGE_DAYS * 24 * 60 * 60 * 1000
const REF_PATTERN = /^[A-Za-z0-9]{4,24}$/

const appDomain = () => (import.meta.env?.VITE_APP_DOMAIN || 'rawajbusiness.com').replace(/^www\./, '')

// Stores live on their own subdomains (shop.rawajbusiness.com); a ?ref there
// is not a marketer link, so only the main site captures it.
function isMainSite(hostname) {
  const domain = appDomain()
  if (!hostname.endsWith(`.${domain}`)) return true
  return hostname === `www.${domain}`
}

function writeCookie(code, hostname, secure) {
  const domain = appDomain()
  // Shared with every subdomain of the main site when served from it.
  const scope = hostname === domain || hostname.endsWith(`.${domain}`) ? `; domain=.${domain}` : ''
  document.cookie = `${KEY}=${encodeURIComponent(code)}; max-age=${MAX_AGE_DAYS * 86400}; path=/; SameSite=Lax${scope}${secure ? '; Secure' : ''}`
}

function readCookie() {
  const match = document.cookie.split('; ').find(part => part.startsWith(`${KEY}=`))
  return match ? decodeURIComponent(match.slice(KEY.length + 1)) : null
}

// Run on every page load: saves ?ref= when the URL has a valid one.
export function captureAffiliateRef(location = window.location) {
  try {
    const code = new URLSearchParams(location.search).get('ref')?.trim()
    if (!code || !REF_PATTERN.test(code) || !isMainSite(location.hostname)) return null
    writeCookie(code, location.hostname, location.protocol === 'https:')
    try { localStorage.setItem(KEY, JSON.stringify({ code, ts: Date.now() })) } catch { /* storage blocked */ }
    return code
  } catch {
    return null
  }
}

// The saved code, if still within 30 days; sent with sign-up.
export function getAffiliateRef() {
  try {
    const fromCookie = readCookie()
    if (fromCookie && REF_PATTERN.test(fromCookie)) return fromCookie
  } catch { /* cookies blocked */ }
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null')
    if (saved?.code && REF_PATTERN.test(saved.code) && Date.now() - Number(saved.ts) < MAX_AGE_MS) return saved.code
  } catch { /* storage blocked or bad value */ }
  return null
}
